import { FacebookPlatform } from '@app/modules/social-export/domain/platforms';
import { PlatformMultiConnect } from '../../../screens/manage/connect/PlatformMultiConnect';
import { facebookConnectAlternatives } from './facebook-connect-alternatives';

/** Facebook multi-method connect: opens alternatives dialog (standard + business). */
export function FacebookConnect() {
  return (
    <PlatformMultiConnect platform={FacebookPlatform} alternatives={facebookConnectAlternatives} />
  );
}
